/**
 * @module logTelemetry
 */

import { TelemetryDetails } from 'owa-actionable-message';
import getTelemetryData from '../utils/getTelemetryData';
import isDevEnvironment from '../utils/isDevEnvironment';
import { lazyGetActionableMessageLogger } from 'owa-analytics';
import { ARIA_CLIENT_EVENT } from '../constants';
import { AWTEventData } from '@aria/webjs-sdk';

/**
 * @function
 * To log telemetry to an Aria tenant
 * @param { TelemetryDetails } telemetryDetails - A telemetry details object
 * @returns A promise that resolve to nothing
 */

const logTelemetry = async (telemetryDetails: TelemetryDetails): Promise<void> => {
    if (isDevEnvironment()) {
        return;
    }
    const dataPoints = getTelemetryData(telemetryDetails);
    const logger = await lazyGetActionableMessageLogger();
    const event: AWTEventData = {
        name: ARIA_CLIENT_EVENT,
        properties: dataPoints || {},
    };
    logger.logEvent(event);
};

export default logTelemetry;
